import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "@/lib/pos-api";
import { setHostKind, clearMasterSelection } from "@/lib/scope";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [tenant, setTenant] = useState(null);
  const [tenantError, setTenantError] = useState("");
  useEffect(() => {
    api.get("/tenant").then(({ data }) => {
      setHostKind(data.kind);
      setTenant(data);
    }).catch(e => setTenantError(apiError(e)));
  }, []);
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pos_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("pos_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    clearMasterSelection();
    localStorage.setItem("pos_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearMasterSelection();
    localStorage.removeItem("pos_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, apiError, tenant, tenantError, readOnly: tenant?.kind === "master" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
